import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
@Component({
  selector: 'app-add-edit-forecast-multi-matrix',
  templateUrl: './add-edit-forecast-multi-matrix.component.html',
  styleUrl: './add-edit-forecast-multi-matrix.component.css',
  standalone: false
})
export class AddEditForecastMultiMatrixComponent implements OnChanges {

  showLoader: boolean = true;
  selectedService: any = {};
  selectedYear: string = '';
  defaultYear: Array<any> = []; // Default year list
  forecastYearList: Array<any> = [];
  forecastServiceList: Array<any> = [];
  forecastMonthList: Array<any> = [
    { name: 'January', currentValue: '1', prevValue: '', key: 'Jan', id: '01' },
    { name: 'February', currentValue: '1', prevValue: '', key: 'Feb', id: '02' },
    { name: 'March', currentValue: '1', prevValue: '', key: 'Mar', id: '03' },
    { name: 'April', currentValue: '1', prevValue: '', key: 'Apr', id: '04' },
    { name: 'May', currentValue: '1', prevValue: '', key: 'May', id: '05' },
    { name: 'June', currentValue: '1', prevValue: '', key: 'Jun', id: '06' },
    { name: 'July', currentValue: '1', prevValue: '', key: 'Jul', id: '07' },
    { name: 'August', currentValue: '1', prevValue: '', key: 'Aug', id: '08' },
    { name: 'September', currentValue: '1', prevValue: '', key: 'Sep', id: '09' },
    { name: 'October', currentValue: '1', prevValue: '', key: 'Oct', id: '10' },
    { name: 'November', currentValue: '1', prevValue: '', key: 'Nov', id: '11' },
    { name: 'December', currentValue: '1', prevValue: '', key: 'Dec', id: '12' }
  ];
  @Input() actionType: string = 'Add'; // 'Add' or 'Edit'
  @Input() selectedData: any = null;
  @Input() tableServiceList: Array<any> = []; // List of services to be displayed in the table
  @Output() saveEvent = new EventEmitter<any>();

  constructor(private maintenanceService: MaintenanceService, private toastr: ToastrService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeData(); // Initialize data when input properties change
  }

  // Initialize data based on action type
  initializeData() {
    if (this.actionType == 'Add') {
      this.initializeDataForAdd();
    } else {
      this.forecastMonthList.forEach((month) => {
        const value = this.selectedData[month.key] || '';
        month.currentValue = value // Set currentValue from selectedData
        month.prevValue = value // Initialize prevValue with currentValue
      });
    }
  }

  //Function to initialize data for Add action
  initializeDataForAdd() {
    this.resetFields(); // Reset fields for Add action
    this.showLoader = true; // Set showLoader to true initially
    this.getForecastYearList();
    this.getForecastServiceData();
  }

  //Function to reset fields
  resetFields() {
    this.forecastYearList = []; // Reset the list
    this.selectedService = {}; // Reset selected services
    this.selectedYear = ''; // Reset selected years
    this.forecastServiceList = []; // Reset forecast service list
  }

  //Function to get the list of forecast years from local storage config
  // This function retrieves the current year from local storage and generates a list of forecast years
  getForecastYearList() {
    const config = sessionStorage.getItem('config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      if (parsedConfig.currentYear) {
        const currentYear = parsedConfig.currentYear;
        this.forecastYearList = [{ name: currentYear, disabled: false }, { name: currentYear + 1, disabled: false }, { name: currentYear + 2, disabled: false }, { name: currentYear + 3, disabled: false }];
      }
    }
  }

  //Function to get the list of forecast service data
  // This function fetches the forecast service data from the maintenance service and processes it
  getForecastServiceData() {
    this.maintenanceService.getForecastServiceData().subscribe(
      (res: Array<any>) => {
        if (res && res.length > 0) {
          this.handleServiceList(res); // Process the service list
        }
        this.showLoader = false; // Set showLoader to false after data is fetched
      },
      (error) => {
        this.handleErrors(error);
        this.showLoader = false; // Set showLoader to false after error
      }
    );
  }

  //Function to handle the service list received from the API
  // This function maps the service data to include a name and checks if the service data exists for all forecast years
  handleServiceList(res) {
    res.map((service: any) => {
      service.name = service.SRVDESC + ' (' + service.Service + ')'; // Ensure 'name' property exists
      service.disabled = this.checkServiceDataExist(service); // Initialize 'disabled' property
    });
    this.forecastServiceList = res;
  }

  //Function to check service data existence for all forecast year lists
  checkServiceDataExist(service: any): boolean {
    // Check if the service exists in any of the forecast years
    const filteredServiceList = this.getFilteredServiceList(service);
    if (filteredServiceList.length === 0) {
      return false; // Service does not exist in the table
    }
    // Check if all forecast years are available for the service
    const availableYears = filteredServiceList.map((item: any) => parseInt(item.year));
    return this.forecastYearList.every((year: any) => availableYears.includes(year.name));
  }

  // Filter the forecastServiceList based on the selected year and service
  getFilteredServiceList(service) {
    const serviceId = service.Service;
    const filteredServiceList = this.tableServiceList.filter((item: any) => item.MULTI_SRV === serviceId);
    return filteredServiceList;
  }

  //Handle the errors while fetching the data
  handleErrors(error: any, message: string = 'Error While Fetching Data') {
    this.showLoader = false;
    this.toastr.error(message, '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  //Function to validate the form before submission
  // This function checks if the form is valid based on the action type
  validateForm() {
    if (this.actionType == 'Add') {
      if (this.selectedService && this.selectedYear && this.checkDataExistForMonth(this.forecastMonthList)) {
        return true; // Form is valid 
      }
    } else if (this.actionType == 'Edit') {
      if (this.checkDataExistForMonth(this.forecastMonthList) && this.checkDataChanged()) {
        return true; // Form is valid
      }
    }
    return false; // Form is invalid
  }

  checkDataChanged() {

    return this.forecastMonthList.some((month) => {
      // Check if currentValue is different from prevValue for any month
      return (parseFloat(month.currentValue) !== parseFloat(month.prevValue));
    });
    // Check if any month's currentValue is different from its prevValue
  }

  checkDataExistForMonth(list: Array<any>): boolean {
    // Check if the list contains any month with currentValue equal to empty string
    return list.every((month) => month.currentValue != '');
  }

  //Function to handle form submission
  // This function constructs a payload based on the selected service, year, and monthly values, and calls the appropriate service method based on the action type
  onSubmit() {
    const payload = {
      "MULTI_SRV": this.selectedService.Service,
      "year": this.selectedYear,
      'SRVDESC': this.selectedService.SRVDESC,
    }
    this.forecastMonthList.forEach((month, i) => {
      payload[month.id] = parseFloat(month.currentValue); // Add each month's current value to the payload
    });
    if (this.actionType === 'Add') {
      this.saveForecastServiceData(payload); // Call save method for Add action
    }
    else if (this.actionType === 'Edit') {
      delete payload['MULTI_SRV']; // Remove MULTI_SRV from payload for Edit action
      delete payload['year']; // Remove year from payload for Edit action
      delete payload['SRVDESC']; // Remove SRVDESC from payload for Edit action
      this.upDateForecastServiceData(payload, this.selectedData.Id); // Call update method for Edit action
    }
  }

  //Function to set the selected year value
  setSelectedYearValue(year: any) {
    this.selectedYear = year.data.name;
  }

  //Function to set the selected service value
  // This function updates the selected service and resets the year list based on the selected service
  setSelectedServiceValue(service: any) {
    this.selectedService = service.data;
    this.defaultYear = [];
    this.selectedYear = ''; // Reset selected year when service changes
    const filteredServiceList = this.getFilteredServiceList(this.selectedService);
    if (filteredServiceList.length > 0) {
      // Set the first available year
      const availableYears = filteredServiceList.map((item: any) => parseInt(item.year));
      this.forecastYearList.forEach((year: any) => {
        year.disabled = availableYears.includes(parseInt(year.name)); // Disable years not available for the selected service    
      });
    } else {
      this.forecastYearList.map((year: any) => {
        year.disabled = false; // Enable all years if no data exists for the selected service
      });
    }
  }

  //Function to validate the number input
  // This function ensures that only numeric values are allowed in the input field
  validateNumber(ev,index) {
    let input = ev.target.value;
    if (input) {
      input = input.replace(/[^0-9.]/g, '');
       const dotIndex = input.indexOf('.');
      // If a dot is present, ensure only one dot exists and the next character is not a dot
      if (dotIndex !== -1 && input.length - dotIndex > 1) {
        if(input.split('.')?.length > 2){
          input = input.slice(0, -1); // Remove the last character if it is not valid
        }else{
          input = input.slice(0, dotIndex + 2); // Limit to one decimal places
        }
      }
        ev.target.value = input;
      if(input === '') {
        this.forecastMonthList[index].currentValue = '';
     }else{
        this.forecastMonthList[index].currentValue = input; // Update the current value in the forecastMonthList
      }
    }
  }

  //Function to save the forecast service data
  // This function constructs a payload based on the selected service, year, and monthly values, and calls the maintenance service to save the data
  saveForecastServiceData(payload) {
    this.showLoader = true; // Show loader while fetching data
    this.maintenanceService.saveForecastMultiMatrix(payload).subscribe((res: any) => {
      if (res) {
        this.closePopup(); // Close the popup after saving data
        this.toastr.success('Forecast Multi Matrix Data Saved Successfully', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
      this.showLoader = false; // Hide loader after saving data
    }, (error) => {
      this.handleErrors(error, 'Error While Saving Forecast Multi Matrix Data');
    })
  }

  //Function to update the forecast service data
  // This function updates the forecast service data based on the provided payload and ID
  upDateForecastServiceData(payload, id) {
    this.showLoader = true; // Show loader while fetching data
    this.maintenanceService.updateForecastMultiMatrix(payload, id).subscribe((res: any) => {
      if (res) {
        this.closePopup(); // Close the popup after saving data
        this.toastr.success('Forecast Multi Matrix Data Updated Successfully', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
      this.showLoader = false; // Hide loader after saving data
    }, (error) => {
      this.handleErrors(error, 'Error While Updating Forecast Multi Matrix Data');
    })
  }

  //Function to close the popup and emit the save event
  closePopup() {
    this.saveEvent.emit({ action: 'save' });
  }

}
